/* eslint react/jsx-filename-extension: 0 */
import React from 'react';
import ReactDOM from 'react-dom';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import RTL from 'assets/jss/rtl';
import 'assets/css/main.css';
import { Provider } from 'react-redux';
import App from 'app';
import { ReactQueryDevtools } from 'react-query/devtools';
import { store } from './store';
import { QueryClient, QueryClientProvider } from 'react-query';
import * as Sentry from '@sentry/browser';
import { initializeInstana } from './utils/instana';
import Swal from 'sweetalert2';
import { premiumDefaults } from './utils/swal';

initializeInstana();

// Apply premium defaults to every Swal.fire call across the app
const originalFire = Swal.fire.bind(Swal);
Swal.fire = (options, ...rest) => {
  if (typeof options === 'object' && options !== null && !Array.isArray(options)) {
    return originalFire({ ...premiumDefaults, ...options });
  }
  // Swal.fire(title, text, type)
  return originalFire({
    ...premiumDefaults,
    title: options,
    text: rest[0],
    type: rest[1],
  });
};

Sentry.init({
  dsn: 'https://aa6f86166ae7f104662d764046a759b2@debug.tamkeen.cloud/124',
  tracesSampleRate: 1.0,
});

const fontFamily = 'FrutigerRegular, Tahoma, Arial, sans-serif';

const theme = createMuiTheme({
  direction: 'rtl',
  typography: {
    useNextVariants: true,
    fontFamily,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
  palette: {
    primary: {
      light: '#33B9C9',
      main: '#00A8BC',
      dark: '#008A9A',
      contrastText: '#ffffff',
    },
    secondary: {
      light: '#F0A35A',
      main: '#E67E22',
      dark: '#C96A1A',
      contrastText: '#ffffff',
    },
    error: {
      main: '#D64545',
    },
    background: {
      default: '#F4F7F8',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#1F2A32',
      secondary: '#6B7780',
    },
  },
  shape: {
    borderRadius: 10,
  },
  overrides: {
    MuiPaper: {
      rounded: {
        borderRadius: 12,
      },
      elevation1: {
        boxShadow: '0 1px 2px rgba(31, 42, 50, 0.04), 0 8px 24px rgba(31, 42, 50, 0.06)',
      },
    },
    MuiButton: {
      root: {
        textTransform: 'none',
        fontWeight: 500,
        borderRadius: 8,
        fontFamily,
      },
    },
    MuiInputBase: {
      root: {
        fontFamily,
      },
    },
    MuiFormLabel: {
      root: {
        fontFamily,
      },
    },
    MuiTypography: {
      root: {
        fontFamily,
      },
    },
    MuiListItemText: {
      primary: {
        fontFamily,
      },
      secondary: {
        fontFamily,
      },
    },
  },
});

const queryClient = new QueryClient();

ReactDOM.render(
  <Provider store={store}>
    <RTL>
      <MuiThemeProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
          <App />
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </MuiThemeProvider>
    </RTL>
  </Provider>,
  document.getElementById('root'),
);
